import React from 'react'
import Link from 'gatsby-link'


const Portfolio = ({ title, projects }) => (
    <div className="portfolio-showcase">
        <div className="container">
            <div className="header">
                <h3>{title}</h3>
                <p>Soluciones técnicas</p>
            </div>
        
            {
                projects.map((project) => {
                    return (
                        <div className="project">
                            <h3>{project.title}</h3>
                            <div className="screen">
                                <img src={project.image()} className="img-fluid" alt="portfolio1" />
                            </div>
                            <p className="description" dangerouslySetInnerHTML={{ __html: project.html }} />
                            <div className="divider"></div>
                            <div className="visit">
                                <Link
                                    className="btn-shadow btn-shadow-primary"
                                    to={project.url}
                                >
                                    Ver solución
                                </Link>
                            </div>
                        </div>
                    )
                })
            }
            
        </div>
    </div>
)

export default Portfolio


// WEBPACK FOOTER //
// ./src/components/Portfolio.js